import { motion } from "framer-motion";

const VIEWPORT = { once: true, amount: 0.2 };
const EASE = [0.22, 1, 0.36, 1];

// Reliable line reveal: each line fades + slides up (no overflow clipping).
export const RevealLines = ({ lines, className = "", delay = 0, stagger = 0.1 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <motion.span
          key={i}
          className="block"
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={VIEWPORT}
          transition={{ duration: 0.85, delay: delay + i * stagger, ease: EASE }}
        >
          {line}
        </motion.span>
      ))}
    </span>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={VIEWPORT}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <FadeUp className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-fuchsiabrand inline-block" />
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-fuchsiabrand">
      {children}
    </span>
  </FadeUp>
);
